import { createPortal } from "react-dom";
import { Dropdown } from "react-bootstrap";
import { Toolbar } from "@bagel-web/components";

import MessageOrderingToggle from "../../viewPreferences/MessageOrderingToggle";
import TextFilterControl from "../TextFilterControl";
import { LimitedListMessageType } from "./limitedListSeed";

// The list's controls: the shared text filter and ordering toggle, plus in
// edit mode the Add menu offering the message types a limited list holds.
const LimitedListToolbar = ({
  componentId,
  isEditMode,
  onAdd,
}: {
  componentId?: string;
  isEditMode?: boolean;
  onAdd: (messageType: LimitedListMessageType) => void;
}) => (
  <Toolbar className="mb-3">
    <TextFilterControl componentId={componentId} />
    <MessageOrderingToggle />
    {isEditMode && (
      <Dropdown>
        <Dropdown.Toggle
          variant="secondary"
          data-testid="limited-list-add-item"
        >
          <i className="bi-plus-lg me-1" />
          Item
        </Dropdown.Toggle>
        {/* Portaled to the body so revealing the menu can't grow the
            card's scroll area; the dropdown context reaches it through
            the portal. */}
        {createPortal(
          <Dropdown.Menu>
            <Dropdown.Item
              className="font-monospace"
              onClick={() => onAdd("ContentMessage")}
              data-testid="limited-list-add-content"
            >
              ContentMessage
            </Dropdown.Item>
            <Dropdown.Item
              className="font-monospace"
              onClick={() => onAdd("FnCallMessage")}
              data-testid="limited-list-add-function-call"
            >
              FnCallMessage
            </Dropdown.Item>
          </Dropdown.Menu>,
          document.body
        )}
      </Dropdown>
    )}
  </Toolbar>
);

export default LimitedListToolbar;
